<div class="container-fluid main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
  <div class="custom-card">
    <div *ngIf="!(afAuth.user | async)" class="alert alert-warning">
      You must be signed in to submit this form. Please <a href="/landing">sign in</a>.
    </div>

    <div class="card-body">
      <h1 class="custom-card-title text-left">New Annual School Profile</h1>
      <h4 class="text-left">Please Fill Out the Following Form</h4>
      <br>

      <form #annualForm = ngForm>
        <div class="mb-3">
          <label for="school" class="me-2"><span class="text-danger">*</span> School:</label>
          <select id="school" (change)="onSchoolChanged()" name="school" class="form-select" [(ngModel)]="formData.school" #school="ngModel" [ngClass]="{'is-invalid': school.invalid && school.touched}" required>
            <option value="" disabled selected hidden></option>
            <option *ngFor="let school of schools" [value]="school.name">
              {{ school.name }}
            </option>
          </select>
        </div>

        <div class="mb-3">
          <label for="schoolYear"><span class="text-danger">*</span> School Year:</label>
          <select
            id="schoolYear"
            class="form-select"
            [(ngModel)]="formData.schoolYear"
            name="schoolYear"
            #schoolYear="ngModel"
            [ngClass]="{'is-invalid': schoolYear.invalid && schoolYear.touched}" required
          >
            <option *ngFor="let year of schoolYears" [value]="year">{{ year }}</option>
          </select>
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <label for="ghsRepresentativeName" class="me-2"><span class="text-danger">*</span> GHS Teacher Representative Name:</label>
            <select id="ghsRepresentativeName" (change)="onTeacherNameChanged()" name="ghsRepresentativeName" class="form-select" [(ngModel)]="formData.ghsRepresentativeName" #ghsRepresentativeName="ngModel" [ngClass]="{'is-invalid': ghsRepresentativeName.invalid && ghsRepresentativeName.touched}" required>
              <option value="" disabled selected hidden></option>
              <option *ngFor="let ghsRepresentative of ghsRepresentativeList" [value]="ghsRepresentative.fullName">
                {{ ghsRepresentative.fullName }}
              </option>
            </select>
          </div>

          <div class="col-6">
            <label for="ghsRepresentativeEmail" class="me-2"><span class="text-danger">*</span> GHS Teacher Representative Email:</label>
            <input id="ghsRepresentativeEmail" class="form-control" [(ngModel)]="formData.ghsRepresentativeEmail" name="ghsRepresentativeEmail" readonly #ghsRepresentativeEmail="ngModel" [ngClass]="{'is-invalid': ghsRepresentativeEmail.invalid && ghsRepresentativeEmail.touched}" required>
          </div>
        </div>

        <div class="mb-3">
          <button class="btn btn-primary d-flex align-items-center" (click)="addAdditionalRep()" style="font-size: smaller">
            Add Additional GHS Representative
            <span class="material-symbols-outlined ms-2">add</span>
          </button>
        </div>

        <div *ngIf="errorMessage" class="text-danger mt-2">
          {{ errorMessage }}
        </div>

        <div *ngIf="wasAddClicked || numOfAdditionalRep > 0">
          <app-annual-school-profiles-form-card
            *ngFor="let repIndex of [].constructor(numOfAdditionalRep); let i = index"
            [teacherList]="getFilteredTeachersForAdditional(i)"
            [(name)]="formData.additionalGhsRepresentativeName[i]"
            [email]="formData.additionalGhsRepresentativeEmail[i]"
            (nameChange)="onAdditionalRepNameChanged(i)"
            (delete)="removeAdditionalRep(i)"
            [number]="i+1">
          </app-annual-school-profiles-form-card>
        </div>

        <div class="mb-3 row">
          <div class="col-6">
            <label for="numStudentsInSchool" class="me-2"><span class="text-danger">*</span> Number of Students Enrolled in School:</label>
            <input type="number" id="numStudentsInSchool" class="form-control" [(ngModel)]="formData.numOfStudents" [ngModelOptions]="{standalone: true}"
                   (ngModelChange)="formData.numOfStudents = $event ? +$event : 0" name="numOfStudents" #numOfStudents="ngModel"
                   min="0" required>
          </div>

          <div class="col-6">
            <label for="numOfTeacherAndStaff" class="me-2"><span class="text-danger">*</span> Number of Teachers and Support Staff:</label>
            <input type="number" class="form-control" id="numOfTeacherAndStaff" [(ngModel)]="formData.numOfTeacherAndStaff" [ngModelOptions]="{standalone: true}"
                   (ngModelChange)="formData.numOfTeacherAndStaff = $event ? +$event : 0" name="numOfStudents" #numOfTeacherAndStaff="ngModel"
                   min="0" required>
          </div>
        </div>

        <div class="mb-1" *ngIf="school.value.toLowerCase().includes('high school')">
          <label for="greenYouthAdvisoryCouncil" class="me-2">Student(s) serving on Green Youth Advisory Council:</label>
          <input id="greenYouthAdvisoryCouncil" class="form-control" maxlength="100" name="studentServingOnGreenYouth" [(ngModel)]="formData.studentServingOnGreenYouth">
        </div>

        <div class="mb-3">
          <label for="goals" class="me-2"><span class="text-danger">*</span> Environmental Education Goals this Year:</label>
          <label *ngFor="let goal of goalsYr" class="form-check mb-2" id="goals">
            <input type="checkbox" class="form-check-input"
                   [checked]="formData.goals.includes(goal)"
                   (change)="toggleGoalSelection(goal, $event)" />
            <span>{{ goal }}</span>
          </label>
        </div>

        <div class="mb-3">
          <label class="me-2"><span class="text-danger">*</span></label>
          <textarea class="form-control" rows="5" id="comment" name="text"
                    placeholder="List your goals for this school year..."
                    [(ngModel)]="formData.goalsComment" #goalsComment="ngModel" maxlength="1000"
                    [ngClass]="{'is-invalid': goalsComment.invalid && goalsComment.touched}" required>
          </textarea>
          <div class="text-end mt-1">
            <small class="text-muted">{{ formData.goalsComment.length || 0 }}/1000</small>
          </div>
        </div>

        <div class="mb-3">
          <label class="me-2">
            School Located within City Limits ?
            <span class="text-danger">*</span>
          </label>

          <input type="radio"
                 name="city"
                 value="Yes"
                 [(ngModel)]="formData.isWithinCityLimits"
                 #limits="ngModel"
                 required>
          <label class="me-2">Yes</label>

          <input type="radio"
                 name="city"
                 value="No"
                 [(ngModel)]="formData.isWithinCityLimits">
          <label class="me-2">No</label>

          <input type="radio"
                 name="city"
                 value="Unknown"
                 [(ngModel)]="formData.isWithinCityLimits">
          <label>Unknown</label>

          <div class="text-danger" *ngIf="limits.invalid && limits.touched">
            Please select an option.
          </div>
        </div>

        <div class="d-flex gap-2 justify-content-center">
          <a routerLink="/annual-school-profiles" class="btn d-flex align-items-center btn-lg"
             style="background-color: red; color: white">
            Cancel without saving
            <span class="material-symbols-outlined ms-1">close</span>
          </a>
          <button id="submitAnnual" type="submit" class="btn btn-primary btn-lg"
                  [disabled]="!annualForm.valid || formData.numOfStudents < 0 || formData.numOfTeacherAndStaff < 0
                            || formData.goals.length < 1"
                  (click)="submitForm()">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>
